import { useEffect, useState } from 'react';

export const APP_PREFERENCE_KEYS = {
  hideKartek: 'mykart_hide_kartek_ai',
  disableKartekTeasers: 'mykart_disable_kartek_teasers',
  reduceMotion: 'mykart_reduce_motion',
  showMobileShortcuts: 'mykart_show_mobile_shortcuts',
  hideHintsAndOnboarding: 'mykart_hide_hints_onboarding',
  hideKartLife: 'mykart_hide_kartlife',
  hideGarage3d: 'mykart_kartlife_hide_garage_3d',
};

const APP_PREFERENCE_DEFAULTS = {
  [APP_PREFERENCE_KEYS.hideKartek]: false,
  [APP_PREFERENCE_KEYS.disableKartekTeasers]: false,
  [APP_PREFERENCE_KEYS.reduceMotion]: false,
  [APP_PREFERENCE_KEYS.showMobileShortcuts]: true,
  [APP_PREFERENCE_KEYS.hideHintsAndOnboarding]: false,
  [APP_PREFERENCE_KEYS.hideKartLife]: false,
  [APP_PREFERENCE_KEYS.hideGarage3d]: false,
};

function dispatchPreferenceChange(key, value) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('mykart:preference-change', { detail: { key, value } }));
}

export function getAppPreference(key) {
  if (typeof window === 'undefined') return APP_PREFERENCE_DEFAULTS[key] ?? false;
  const raw = window.localStorage.getItem(key);
  if (raw == null) return APP_PREFERENCE_DEFAULTS[key] ?? false;
  return raw === '1';
}

export function setAppPreference(key, value) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key, value ? '1' : '0');
  dispatchPreferenceChange(key, !!value);
}

// A preference as React state, kept in step with the settings page and other tabs.
export function useAppPreference(key) {
  const [value, setValue] = useState(() => getAppPreference(key));
  useEffect(() => {
    const sync = () => setValue(getAppPreference(key));
    const onChange = event => { if (event.detail?.key === key) sync(); };
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener('mykart:preference-change', onChange);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('mykart:preference-change', onChange);
    };
  }, [key]);
  return value;
}

export function getHideKartekPreference() {
  return getAppPreference(APP_PREFERENCE_KEYS.hideKartek);
}

export function setHideKartekPreference(value) {
  setAppPreference(APP_PREFERENCE_KEYS.hideKartek, value);
}
